import AppDrawerContainer from '@nxsys/components/AppDrawerContainer';
import type { RequiredAlertsListType } from '@nxsys/store/slices/dashboard/types';
import React from 'react';
import EmployeeDetail from '../../../employees/detail';
import { ALERT_EDIT_TARGET } from './editAlertTargets';

type RequiredAlertEditDrawerProps = {
  isOpen: boolean;
  workerId: string | null;
  type: RequiredAlertsListType;
  title: string;
  toggle: () => void;
};

const RequiredAlertEditDrawer: React.FC<RequiredAlertEditDrawerProps> = ({
  isOpen,
  workerId,
  type,
  title,
  toggle,
}) => {
  const target = ALERT_EDIT_TARGET[type];

  return (
    <AppDrawerContainer
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      width={960}
    >
      {/* Mount fresh per open so the fetch + auto-focus effects re-run, and
          unmount on close so EmployeeDetail clears its Redux detail slice. */}
      {isOpen && workerId && target && (
        <EmployeeDetail
          embedded
          employeeId={workerId}
          initialTab={target.tab}
          focusField={target.field}
        />
      )}
    </AppDrawerContainer>
  );
};

export default RequiredAlertEditDrawer;
